import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PanelItemHeader } from '../../../../panels/panelItemHeader';
import { useAppSelector } from '../../../../redux/store';
import { ROOM_INFO_PANEL_HEADER_COLOR } from '../../../../styles/colors';
import { range } from '../../../../utils/utils';
import { TourneyStandingsPlayerDisplay } from './tourneyStandingsPlayerDisplay';
export const TourneyStandingsPlayersContainer = ({ header, playerType, showChips }) => {
    const numPlayersOfType = useAppSelector((state) => playerType === 'active' ? state.mtt.activePlayers.length : state.mtt.finishedPlayers.length);
    if (!numPlayersOfType) {
        return null;
    }
    // use showChips as a simple differentiator for creating a unique ID:
    const ariaLabelId = `tourney-standings-players-${showChips ? 'with-chips' : 'without-chips'}`;
    return (_jsxs("section", { "aria-labelledby": ariaLabelId, children: [_jsx(PanelItemHeader, { backgroundColor: ROOM_INFO_PANEL_HEADER_COLOR, id: ariaLabelId, children: header }), range(numPlayersOfType).map((playerIndex) => (_jsx(TourneyStandingsPlayerDisplay, { playerType: playerType, playerIndex: playerIndex, showChips: showChips }, playerIndex)))] }));
};
